export default __webpack_public_path__ + "static/media/depositWithdrawalIcon4.542d66d2.webp";